import { Helmet } from 'react-helmet';
import { useState } from 'react';
import { useTranslation } from 'react-i18next'; // Assuming you're using react-i18next
import styles from './CancelConfirmation.module.css';
import HeroSection from '../../../components/Verification/HeroSection/HeroSection';
import SimpleLink from '../../../components/UI/Buttons/SimpleLink/SimpleLink';
import BubbleButton from '../../../components/UI/Buttons/BubbleButton/BubbleButton';

function CancelConfirmation({ cancelSubscription }) {
    const { t } = useTranslation();
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const handleCancelSubscription = () => {
        if (isChecked) {
            cancelSubscription()
            // alert(t('CancelConfirmation.alerts.success'));
        }
    };

    return (
        <div className={styles.wrapper}>
            <Helmet>
                <title>FindCV - {t('CancelConfirmation.title')}</title>
            </Helmet>
            <div className={styles.container}>
                <div className={styles.HeroSectionWrapper}>
                    <HeroSection
                        title={t('CancelConfirmation.title')}
                        desc={t('CancelConfirmation.descriptionUpdate')}
                    />
                </div>
                <div className={styles.confirmationWrapper}>
                    <div className={styles.checkboxContainer}>
                        <input
                            type="checkbox"
                            id="cancelConfirmationCheckbox"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                            className={styles.checkbox}
                        />
                        <label htmlFor="cancelConfirmationCheckbox" className={styles.checkboxLabel}>
                            {t('CancelConfirmation.checkboxLabel')}
                        </label>
                    </div>
                    <BubbleButton
                        onClick={handleCancelSubscription}
                        headerButton
                        disabled={!isChecked} // Disable button if not checked
                        style={{
                            cursor: isChecked ? 'pointer' : 'not-allowed',
                            opacity: isChecked ? 1 : 0.5, // Optional styling for disabled state
                        }}
                    >
                        <span style={{ color: 'red' }}>{t('CancelConfirmation.buttonText')}</span>
                    </BubbleButton>
                </div>
            </div>
        </div>
    );
}

export default CancelConfirmation;
